let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hx4kR")).then(() => parcelRequire('1HQaj'));